import './modal.scss';

export { Modal, ModalActions, ModalHeader } from '@lambdacurry/component-library';
